<template>
  <div class="v-card">
    <div class="v-header">
      <h3 class="v-title" v-if="title">
        {{ title }}
        <el-tooltip v-if="fourSectionAnalysis" class="item" effect="dark" placement="top">
          <div
            slot="content"
            style="line-height:20px;width:400px"
          >四分位数是指处在25%位置上的数值（称为下四分位数q1）和处在75%位置上的数值（称为上四分位数q3）</div>
          <img
            style="height:14px;vertical-align: middle;margin-left: 5px;margin-top: -3px"
            src="~images/explain.png"
            alt
          />
        </el-tooltip>
      </h3>
      <div class="v-center">
        <slot name="center"></slot>
      </div>
      <div class="v-footer">
        <slot name="footer"></slot>
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false
    },
    fourSectionAnalysis: {
      type: Boolean,
      required: false
    }
  }
};
</script>

<style scoped lang="scss">
.v-card {
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  background: #fff;
  box-shadow: $box-shadow;
  padding: 6px 25px 20px;
  margin-bottom: 20px;
  .v-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .v-title {
      flex: 1;
      white-space: nowrap;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      color: #333;
      font-weight: bold;
      &:before {
        margin-top: -4px;
        display: inline-block;
        content: "";
        width: 7px;
        height: 7px;
        vertical-align: middle;
        background: $color-theme;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
    .v-center {
      flex: 1;
      white-space: nowrap;
      text-align: right;
    }
    .v-footer {
      flex: 1;
      white-space: nowrap;
      text-align: right;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/card/VCard.vue